import BRHead from './BRHead'
import { lazy, Suspense } from 'react'

const BRWorkflow = lazy(() => import("./BRWorkflow"));
const BRMobility = lazy(() => import("./BRMobility"));
const BRElectricBike = lazy(() => import("./BRElectricBike"));
const BRLeaders = lazy(() => import("./BRLeaders"));
const BRWhyWait = lazy(() => import("./BRWhyWait"));
const BRWebBooking = lazy(() => import("./BRWebBooking"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));
const OnDemandWork = lazy(() => import('../cloneApps/onDemand/OnDemandWork'));

const faqData = [
  {
    id: "0",
    question: "01. How does Mobility Infotech’s Bike Rental Solution work?",
    answer: "Our platform provides a comprehensive solution to manage and scale your bike rental business. From booking to payments and fleet management, our system streamlines all operations in one place.",
  },
  {
    id: "1",
    question: "02. Can I customize the bike rental platform to match my brand?",
    answer: "Yes, our bike rental solution is fully customizable. You can add your branding, set pricing, and modify features to meet your specific business needs.",
  },
  {
    id: "2",
    question: "03. Does the system support real-time bike tracking?",
    answer: "Absolutely! Our solution includes GPS tracking, allowing you to monitor bikes in real time and optimize their distribution across locations.",
  },
  {
    id: "3",
    question: "04. What payment methods are supported in the system?",
    answer: "Our platform supports a wide range of payment options, including credit/debit cards, mobile payments, and digital wallets, ensuring a seamless transaction experience for users.",
  },
  {
    id: "4",
    question: "05. Is the platform scalable for large fleets?",
    answer: "Yes, the platform is built to handle bike fleets of all sizes. Whether you have a small fleet or hundreds of bikes, our system can scale effortlessly.",
  },
  {
    id: "5",
    question: "06. How does the platform handle maintenance alerts and bike health?",
    answer: "The platform features automatic maintenance alerts based on bike usage and performance, helping you keep your fleet in top condition.",
  }
];

export default function BikeRental() {
  const bikeRentalFeatureId = 'bike-rental-software';
  return (
    <>
      <BRHead featureId={bikeRentalFeatureId} />

      <Suspense fallback={null}>
        <BRWorkflow />
        <BRMobility />
        <BRElectricBike />
        <BRLeaders />
        <BRWhyWait />
        <BRWebBooking />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <ShuttleAppreciation />
        <ShuttleItNeed featureId={bikeRentalFeatureId} />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
